import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getPrimaryFiltersOptionsAction } from '../actions';

const {
  useLoaderData: StudentRiskPrimaryFiltersLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({ action: getPrimaryFiltersOptionsAction });

function StudentRiskPrimaryFiltersLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentRiskPrimaryFiltersLoader, StudentRiskPrimaryFiltersLoaderData };
